import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01538e3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "oxd-tree-node-toggle"
}
const _hoisted_2 = { class: "oxd-tree-node-content" }
const _hoisted_3 = {
  key: 0,
  class: "oxd-tree-node-child"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon_button = _resolveComponent("oxd-icon-button")!
  const _component_oxd_tree_node = _resolveComponent("oxd-tree-node")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["oxd-tree-node", _ctx.nodeClasses])
  }, [
    (_ctx.showRoot)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: _ctx.cuid,
          class: _normalizeClass([_ctx.nodeClasses, "oxd-tree-node-wrapper"])
        }, [
          (_ctx.hasChildren)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _createVNode(_component_oxd_icon_button, {
                  onClick: _ctx.onClickNode,
                  name: _ctx.isOpen ? 'chevron-up' : 'chevron-down',
                  role: "none"
                }, null, 8, ["onClick", "name"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "content", { nodeData: _ctx.currentNode }, undefined, true),
            (!_ctx.$slots['content'])
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.data.name), 1)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "oxd-tree-node-liner",
      style: _normalizeStyle(_ctx.lineStyles)
    }, null, 4),
    (_ctx.hasChildren)
      ? (_openBlock(), _createBlock(_Transition, {
          key: 1,
          name: _ctx.animation,
          onAfterLeave: _ctx.onAnimationComplete
        }, {
          default: _withCtx(() => [
            (_ctx.isOpen)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.children, (child, index) => {
                    return (_openBlock(), _createBlock(_component_oxd_tree_node, {
                      key: child.cuid,
                      data: child,
                      animation: _ctx.animation,
                      isLast: index + 1 === _ctx.data.children.length
                    }, _createSlots({ _: 2 }, [
                      _renderList(_ctx.$slots, (_, name) => {
                        return {
                          name: name,
                          fn: _withCtx((slotData) => [
                            _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotData)), undefined, true)
                          ])
                        }
                      })
                    ]), 1032, ["data", "animation", "isLast"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["name", "onAfterLeave"]))
      : _createCommentVNode("", true)
  ], 2))
}